// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"83e03a71","765":"d7885511"}[chunkId] + ".chunk.js";
};